<ul>
  <li *ngFor="let scenario of scenarios" (click)="runScenario(scenario)">
    {{ scenario.name }}
  </li>
</ul>
